import { forwardAuthorization } from './storageWorker/handles.js'
import { messages } from './storageWorker/messages.js'
import Pocketbase from 'pocketbase'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import ReactDOM from 'react-dom/client';

const backend = "https://access-okeeffe.pockethost.io"

const ContextToolbar = ({ entityId, filenameSlug }) => {
  // UI state
  const [listsStatus, setListsStatus] = useState({})
  const [activeCount, setActiveCount] = useState(0)
  const [listsCount, setListsCount] = useState(0)

  // Worker, worker state + communication
  // NB: Overrides webpack 5's publicDir setting for the worker bundle
  __webpack_public_path__ = "/assets/"
  const storageWorker = useMemo(() => new Worker( new URL('./storageWorker/index.mjs', import.meta.url) ), [])
  const [ready, setReady] = useState(false)

  const workerPort = useRef(null)
  const broadcast = useMemo(() => new BroadcastChannel('cr-lists-storage'), [])

  const messageHandler = (event) => {
    const { data: eventData } = event

    const { data, proxy, type } = eventData
    if (proxy) {
      window.dispatchEvent(new CustomEvent('storage-proxy-return', {detail: eventData}))
      // TODO: Reload status
      return
    }

    switch (type) {
      case messages.STORAGE_UPDATED:
        loadStorageData()
        break
      case messages.WORKER_READY:
        setReady(true)
        break
      case messages.ITEM_STATUS:
        const status = data.reduce((acc,cur) => {
          acc[cur.id] = true
          return acc
        }, {})

        setListsStatus({...status})

        setActiveCount(data.filter(d => d.status).length)
        setListsCount(data.length)
        break
      case messages.SAVE_LIST:
      case messages.REMOVE_ITEM_FROM_LIST:
      case messages.ADD_ITEM_TO_LIST:
      case messages.CREATE_DEFAULT_LIST:
        // TODO: ok, no-op -- consider using this to UI signal save finish
        break
      default:
        console.warn(`Got an unrecognized message type, ${type}`)
        return
    }
  }

  const messageProxy = (event) => {
    const { detail: data } = event

    workerPort.current.postMessage({ ...data, proxy: true })
  }

  const loadStorageData = () => {
    workerPort.current.postMessage({ type: messages.ITEM_STATUS, id: entityId })
  }

  const handleBroadcast = (event) => {
    const { data } = event
    const { type } = data

    switch (type) {
      case messages.STORAGE_UPDATED:
        loadStorageData()
        break
      default:
        console.warn(`Unknown broadcast ${type}`)
    }
  }

  // Storage worker init: add listener hook
  useEffect(() => {
    storageWorker.addEventListener('message', (event) => {
      const { data } = event
      const { type, port } = data

      if (type === messages.WORKER_READY) {
        workerPort.current = port
        workerPort.current.onmessage = messageHandler

        forwardAuthorization(backend, port)
        setReady(true)
      }
    })
  },[storageWorker])

  useEffect(() => {
    if (!ready) return
    loadStorageData()

    // Component acts as a proxy to storage for on-page vanilla JS, set up proxy handler
    window.addEventListener('storage-proxy', messageProxy)
    window.dispatchEvent(new CustomEvent('storage-proxy-ready'))

    // Attach to the storage broadcast for updates from other tabs
    broadcast.onmessage = handleBroadcast
  },[ready])

  const handleNextButton = () => {
    console.log('next click')
  }

  const handlePrevButton = () => {
    console.log('prev click')
  }

  const openModal = (event) => {
    const modalTarget = event.currentTarget.dataset.target
    window.postMessage({type: 'open-modal', id: modalTarget}, location.origin)
  }

  const printPage = () => {
    window.print()
  }

  const downloadPDF = async (event) => {
    try {

      const assetUrl = `access-okeeffe-${ entityId.split('/').at(-1) }.pdf`
      const pdfUrl = `./${assetUrl}`
      const filename = `${ filenameSlug }.pdf`
      const response = await fetch(pdfUrl)
      const blob = await response.blob()

      const pdfBlobUrl = URL.createObjectURL(blob)

      const anchor = document.createElement('a')
      anchor.href = pdfBlobUrl
      anchor.download = filename

      anchor.click()
    } catch (error) {
      console.error(error)
    }
  }

  const handleListAddRemove = (event) => {
    if (!ready) return

    openModal(event)
  }

  const savedLabel = () => 'Saved' + (activeCount > 1 ? `(${activeCount})` : '')

  return <React.Fragment>
        <div className="page-nav-links is-hidden">
          <a className="page-nav-set">Name of Set</a>
          <a className="page-nav-link prev" onClick={handlePrevButton} ><i className="icon icon-carat-left"></i>Previous</a>
          <a className="page-nav-link next" onClick={handlePrevButton} >Next <i className="icon icon-carat-right"></i></a>
        </div>
        <div className="ml-auto mr-2">
          <button className="button is-text"
                  data-target="add-to-list-modal"
                  data-tooltip="Add to bookmark"
                  title="Add to bookmark"
                  onClick={handleListAddRemove} >
            <span className={`text-white ${activeCount ? 'is-inline-block' : 'is-hidden'}`}>
               { savedLabel() }
            </span>

            <img className={`${activeCount ? 'is-hidden' : 'is-inline-block'}`}
            src="/assets/svg/icon_bookmark_tool.svg" alt="add to list" />

            <img className={`${activeCount ? 'is-inline-block' : 'is-hidden'}`}
            src="/assets/svg/icon_bookmark_checked_tool.svg" alt="already added to list" />

            <span className="sr-only">Bookmark</span>
          </button>
          <button className="button is-text js-modal-trigger"
                  data-target="add-citation-modal"
                  data-tooltip="Copy citation"
                  title="Copy citation"
                  onClick={openModal} >
            <span className="icon icon-quote-tool">
            </span>
            <span className="sr-only">Quote</span>
          </button>
          <button className="button is-text js-modal-trigger"
                  data-tooltip="Download PDF"
                  title="Download PDF"
                  onClick={downloadPDF} >
            <span className="icon icon-download-tool">
            </span>
            <span className="sr-only">Download</span>
          </button>
          <button className="button is-text"
                  data-tooltip="Print PDF"
                  title="Print PDF"
                  onClick={printPage} >
            <span className="icon icon-print-tool">
            </span>
            <span className="sr-only">Print</span>
          </button>
        </div>
      </React.Fragment>
}

document.addEventListener('DOMContentLoaded',() => {
  const el = document.getElementById('contextToolbarRoot');
  if (!el) return

  const { entityId, filenameSlug } = el.dataset

  ReactDOM.createRoot(el).render(
    <ContextToolbar entityId={entityId} filenameSlug={filenameSlug} />
  )
})